import cn from "classnames";
import styles from "./style.module.less";
export function LockIcon() {
    return <em className={cn("fa fa-lock", styles.lockIcon)}/>;
}
